import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import SudokuPlayer from './players/SudokuPlayer';
import { fetchJson, sitePath } from '../lib/api';
import { getPuzzleAdapter } from '../puzzles/registry';

export default function PuzzlePage() {
  const { puzzleSlug } = useParams();
  const [puzzle, setPuzzle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetchJson(sitePath(`/play/${puzzleSlug}`))
      .then((json) => {
        const record = json.data;
        if (!record) {
          throw new Error('Puzzle not found');
        }
        setPuzzle(record);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [puzzleSlug]);

  if (loading) {
    return (
      <>
        <Header />
        <main className="mx-auto max-w-6xl px-4 py-8">
          <div className="rounded-[1.5rem] border border-slate-200 bg-white/85 p-6 text-sm text-slate-600 shadow-lg shadow-slate-200/40">
            Loading puzzle…
          </div>
        </main>
      </>
    );
  }

  if (error || !puzzle) {
    return (
      <>
        <Header />
        <main className="mx-auto max-w-6xl space-y-5 px-4 py-8">
          <div className="rounded-[1.5rem] border border-rose-200 bg-white/85 p-6 shadow-lg shadow-slate-200/40">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-rose-600">
              Puzzle unavailable
            </p>
            <p className="mt-3 text-sm leading-7 text-slate-700">
              {error || 'Puzzle data not available.'}
            </p>
            <Link
              to="/catalog"
              className="mt-4 inline-flex rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-magenta"
            >
              Return to catalog
            </Link>
          </div>
        </main>
      </>
    );
  }

  const adapter = getPuzzleAdapter(puzzle.puzzleType.slug);

  return (
    <>
      <Header />
      <main className="mx-auto max-w-6xl px-4 py-8">
        {adapter ? (
          <SudokuPlayer puzzle={puzzle} adapter={adapter} />
        ) : (
          <div className="rounded-[1.5rem] border border-amber-200 bg-white/90 p-6 shadow-lg shadow-slate-200/40">
            <p className="text-sm leading-7 text-slate-700">
              This puzzle type is listed in the catalog, but the online player is not ready yet.
            </p>
            <Link
              to={`/catalog/${puzzle.puzzleType.slug}`}
              className="mt-4 inline-flex rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-magenta"
            >
              Back to {puzzle.puzzleType.name}
            </Link>
          </div>
        )}
      </main>
    </>
  );
}
